export const NEWS_TYPE = {
    MARKET: 1,
    STOCK: 2,
    CUSTOM: 3
};

export const isStockNewsType = (type) => {
    return type === NEWS_TYPE.STOCK;
};

export const isCustomNewsType = (type) => {
    return type === NEWS_TYPE.CUSTOM;
};
